import { ProductOrderItemSerializable } from './product-order-item-serializable';
import * as models from '../../../../domain/models';

export class MembershipOrderItemSerializable extends ProductOrderItemSerializable {
  salesAction: models.SalesActionEnum = null;
  managedClientServiceId: number = null;
  managedLsegacyMembershipPeriodId: number = null;
  referredByClientId: number = null;
}
